export const BranchSummaryLogsSelector = ({
  viewDetails: { BranchSummaryLogs }
}) => BranchSummaryLogs;

export const AssociationChangeLogSelector = ({
  dashboard:
    { AssociationChangeLog }
}) => AssociationChangeLog;
